import { ThemeToggle } from '@origens/ui/theme'

export function ThemeToggleClient() {
  return <ThemeToggle className="landing__theme" />
}
